import { Component } from '@angular/core';
import { CxAdvFiltersDataService } from '../cx-adv-filters-data.service';
import { Field } from '../cx-adv-filters.types';
import { CxAdvFiltersService } from '../cx-adv-filters.service';
import { cloneDeep } from '../utils';

@Component({
  selector: 'cx-adv-filters-fields',
  templateUrl: './cx-adv-filters-fields.component.html',
  styleUrl: './cx-adv-filters-fields.component.scss'
})
export class CxAdvFiltersFieldsComponent {
  query = '';
  fields: Array<any> = this.cadvDataFilters.fields;
  SCREENS = this.cadvFilters.SCREENS;

  constructor (public cadvFilters: CxAdvFiltersService, public cadvDataFilters: CxAdvFiltersDataService) {}

  onFieldSelect(e: MouseEvent, field: Field) {
    e.preventDefault();
    this.cadvFilters.currentScreen = this.SCREENS.TWO;
    field.isNew = true;
    this.cadvFilters.currentField = cloneDeep(this.cadvDataFilters.mapFieldOption(field));
    (this.cadvFilters.currentField as Field).fid = 'f-' + String((new Date().getTime()));
    (this.cadvFilters.currentField as Field).step = 2;
  }

  onAdvanceFiltersClick (e: MouseEvent) {
    if (this.cadvFilters.getFiltersLength() > 0) {
      this.cadvFilters.currentScreen = this.SCREENS.THREE;
    }
  }
}
